var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Link } from '../Link';
import { ButtonContainer, ButtonLink, CalloutButton } from './elements';
var ActionsOrLink = function (_a) {
    var primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton, linkOne = _a.linkOne;
    return (React.createElement(React.Fragment, null,
        primaryButton && (React.createElement(CalloutButton, { size: "small", variant: "outline", iconSrc: undefined, iconSide: "right", disabled: false, onClick: primaryButton.onClick, className: secondaryButton && 'callout-button-margin-right' }, primaryButton.text)),
        secondaryButton && (React.createElement(CalloutButton, { size: "small", variant: "flat", iconSrc: undefined, iconSide: "right", disabled: false, onClick: secondaryButton.onClick }, secondaryButton.text)),
        !primaryButton && !secondaryButton && linkOne && (React.createElement(Link, { href: linkOne.href, color: "primary", iconSrc: undefined, iconSide: "right", disabled: false, onClick: linkOne.onClick }, linkOne.text))));
};
var CompressButton = function (_a) {
    var isCompressed = _a.isCompressed, onClick = _a.onClick;
    return (React.createElement(ButtonLink, { size: "small", variant: "flat", iconSide: "right", iconSrc: undefined, disabled: false, className: "asurion-ui-callout-compression-button", onClick: onClick }, isCompressed ? 'See more' : 'See less'));
};
export var CalloutActions = function (_a) {
    var primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton, linkOne = _a.linkOne, compressionEnabled = _a.compressionEnabled, isCompressed = _a.isCompressed, setIsCompressed = _a.setIsCompressed;
    var hasAction = primaryButton || secondaryButton || linkOne;
    if (!hasAction && !compressionEnabled) {
        return null;
    }
    return (React.createElement(ButtonContainer, null, !compressionEnabled ? (React.createElement(ActionsOrLink, __assign({}, { primaryButton: primaryButton, secondaryButton: secondaryButton, linkOne: linkOne }))) : (React.createElement(CompressButton, { isCompressed: isCompressed, onClick: function () { return setIsCompressed(function (compressed) { return !compressed; }); } }))));
};
